import { Dimension } from 'src/@enums'
import { BusinessUnitShortType } from 'src/@types'
import { gaEvent, getDimensionByUnit } from 'src/utils'

/**
 * Parâmetro para {@link dimensionTransactionIdEvent}
 */
export type DimensionTransactionIdType = BusinessUnitShortType & {
  transactionId: string
}

/**
 * [TARGET]: Correlaciona o número da transação com a dimension das respectivas marcas.
 *
 * [CONTEXTO]: : A dimension por default será a ‘dimension21’, para businessUnit EUD a dimension será a ‘dimension19’.
 *
 * [REGRAS]: n/a
 *
 */

export const dimensionTransactionIdEvent = ({
  businessUnit,
  transactionId,
}: DimensionTransactionIdType) => {
  gaEvent({
    [getDimensionByUnit(Dimension.TRANSACTION_ID, businessUnit)]: transactionId,
  })
}
